import "./login.css";
import logo from "../../assets/img/ht-logo-login.svg";
import { useEffect } from "react";
import { useAuth } from "@hoteltradergit/user-management/auth";
import { useNavigate } from "react-router-dom";
import ProgressLoader from "../../components/progress-loader/ProgressLoader";

function LoginPage() {
  const { login, idToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (idToken) {
      navigate("/");
    } else {
      login();
    }
  }, [idToken, login, navigate]);

  return (
    <div className="auth">
      <div className="auth-container">
        <div className="login-logo">
          <img src={logo} className="logo" alt="Hoteltrader" />
        </div>
        <div className="login-title font-13">Supplier Portal</div>
      </div>
      <div className="loader-container">
        <ProgressLoader />
      </div>
    </div>
  );
}

export default LoginPage;
